import { getData2 } from "../../pages/dashboard/dev.getdata";

const resolvers = {
  Query: {
    heatmapData: (obj: any, args: any, context: any, info: any) => {
      const { startDate, endDate } = args;
      const data = getData2(startDate, endDate);
      return data;
    }
  },
  Mutation: {}
};

export default resolvers;
